"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatLinkTitle = void 0;
var _formatName = require("./formatName");
const formatLinkTitle = _ref => {
  let {
    developerName,
    name
  } = _ref;
  let title = (0, _formatName.formatName)(name);
  if (developerName) {
    title += ` от ${developerName}`;
  }
  return title;
};
exports.formatLinkTitle = formatLinkTitle;